import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import routes from 'helpers/routes';
import { useUserData } from 'hooks/useUserData';
import './Navigation.scss';

const Navigation = () => {
    const { data: user } = useUserData(); // TODO This doesn't update on login/logout

    // Get all navigable routes
    const navItems = Object.entries(routes)
        .filter(([pageName, route]) => route.showInNav !== false)
        .filter(([pageName, route]) => user || (route as any).public) // Show public pages
        .map(([pageName, route]) => ({ pageName, route }));

    // Separate left and right navigation items
    const leftNavItems = navItems.filter(item => !item.route.right);
    const rightNavItems = navItems.filter(item => item.route.right);

    // Group left routes by their first path segment
    const leftGroupedRoutes = leftNavItems.reduce((groups, { pageName, route }) => {
        const pathParts = route.path.split('/').filter(Boolean);
        const firstSegment = pathParts.length > 0 ? pathParts[0] : 'main';

        if (!groups[firstSegment]) groups[firstSegment] = [];
        groups[firstSegment].push({ pageName, route });
        return groups;
    }, {} as Record<string, Array<{ pageName: string; route: any }>>);

    // Group right routes by their first path segment
    const rightGroupedRoutes = rightNavItems.reduce((groups, { pageName, route }) => {
        const pathParts = route.path.split('/').filter(Boolean);
        const firstSegment = pathParts.length > 0 ? pathParts[0] : 'main';

        if (!groups[firstSegment]) groups[firstSegment] = [];
        groups[firstSegment].push({ pageName, route });
        return groups;
    }, {} as Record<string, Array<{ pageName: string; route: any }>>);

    // Helper function to format group names
    const formatGroupName = (groupKey: string) => {
        return groupKey.charAt(0).toUpperCase() + groupKey.slice(1);
    };

    return (
        <header>
            <Navbar bg="light" expand="md">
                <Container>
                    <Navbar.Brand as={Link} to={routes.Home.path} title='Home'>
                        <img className='logo' src='/images/logo.png' alt='Home' />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            {/* TODO Remove duplicated code below and simplify this */}
                            {/* Render left navigation items */}
                            {Object.entries(leftGroupedRoutes).map(([groupKey, groupRoutes]) => {
                                if (groupRoutes.length === 1) {
                                    // Single item - render as regular nav link
                                    const { pageName, route } = groupRoutes[0];
                                    return (
                                        <Nav.Link as={Link} to={route.path} key={pageName}>
                                            {pageName}
                                        </Nav.Link>
                                    );
                                } else {
                                    // Multiple items - render as dropdown
                                    const groupName = groupKey === 'user' ? (user?.username || 'User') : formatGroupName(groupKey);
                                    return (
                                        <NavDropdown title={groupName} id={`${groupKey}-nav-dropdown`} key={groupKey}>
                                            {groupRoutes.map(({ pageName, route }) => (
                                                <NavDropdown.Item as={Link} to={route.path} key={pageName}>
                                                    {pageName}
                                                </NavDropdown.Item>
                                            ))}
                                        </NavDropdown>
                                    );
                                }
                            })}
                        </Nav>
                        <Nav className="ms-auto">
                            {/* Render right navigation items */}
                            {Object.entries(rightGroupedRoutes).map(([groupKey, groupRoutes]) => {
                                if (groupRoutes.length === 1) {
                                    // Single item - render as regular nav link
                                    const { pageName, route } = groupRoutes[0];
                                    return (
                                        <Nav.Link as={Link} to={route.path} key={pageName}>
                                            {pageName}
                                        </Nav.Link>
                                    );
                                } else {
                                    // Multiple items - render as dropdown
                                    const groupName = groupKey === 'user' ? (user?.username || 'User') : formatGroupName(groupKey);
                                    return (
                                        <NavDropdown title={groupName} id={`${groupKey}-nav-dropdown`} key={groupKey}>
                                            {groupRoutes.map(({ pageName, route }) => (
                                                <NavDropdown.Item as={Link} to={route.path} key={pageName}>
                                                    {pageName}
                                                </NavDropdown.Item>
                                            ))}
                                        </NavDropdown>
                                    );
                                }
                            })}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default Navigation;